import axios from "axios";
import { createContext } from "react";

const AIAssistantContext = createContext();

export const AIAssistantContextProvider = ({ children }) => {
  const getAIAssistants = (skip, take) => {
    return axios.get(`/api/ai/assistants?skip=${skip}&take=${take}`);
  };

  const getAIAssistant = (id) => {
    return axios.get("/api/ai/assistants/" + id);
  };

  const createAIAssistant = (data) => {
    return axios.post("/api/ai/assistants", data);
  };

  const updateAIAssistant = (data) => {
    return axios.put("/api/ai/assistants/" + data.id, data);
  };

  const deleteAIAssistant = (id) => {
    return axios.delete("/api/ai/assistants/" + id);
  };

  return (
    <AIAssistantContext.Provider
      value={{
        getAIAssistants,
        getAIAssistant,
        createAIAssistant,
        updateAIAssistant,
        deleteAIAssistant,
      }}
    >
      {children}
    </AIAssistantContext.Provider>
  );
};

export default AIAssistantContext;
